document.addEventListener("DOMContentLoaded", function () {
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ─── Sticky / floating header ────────────────────────────────────────────
  var header = document.querySelector(".js-site-header");
  if (header) {
    var toggleHeaderState = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 40);
    };
    window.addEventListener("scroll", toggleHeaderState, { passive: true });
    toggleHeaderState();
  }

  // ─── Scroll-reveal (fade/rise + SVG line-draw) ───────────────────────────
  var revealTargets = document.querySelectorAll(".reveal-on-scroll, .js-draw-line");
  if (revealTargets.length) {
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      revealTargets.forEach(function (el) {
        el.classList.add("is-visible");
      });
    } else {
      var revealObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var target = entry.target.closest(".reveal-on-scroll") || entry.target;
            target.classList.add("is-visible");
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );
      revealTargets.forEach(function (el) {
        revealObserver.observe(el);
      });
    }
  }

  // ─── Animated stat counters ───────────────────────────────────────────────
  var counters = document.querySelectorAll(".js-counter");
  if (counters.length) {
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      return;
    }
    var counterObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  function animateCounter(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/[\d.,]+/);
    if (!match) return;

    var numericTarget = parseFloat(match[0].replace(/,/g, ""));
    if (isNaN(numericTarget)) return;

    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + match[0].length);
    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(numericTarget * eased);
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = raw;
      }
    }

    window.requestAnimationFrame(step);
  }

  // ─── Subtle hero/decoration parallax ─────────────────────────────────────
  var parallaxEls = document.querySelectorAll(".js-parallax");
  if (parallaxEls.length && !prefersReducedMotion) {
    var ticking = false;
    var updateParallax = function () {
      parallaxEls.forEach(function (el) {
        var speed = parseFloat(el.getAttribute("data-parallax-speed")) || 0.15;
        el.style.transform = "translateY(" + window.scrollY * speed + "px)";
      });
      ticking = false;
    };
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      },
      { passive: true }
    );
    updateParallax();
  }

  // ─── Mouse-move parallax (hero decoration) ────────────────────────────────
  // Drifts every `.js-mouse-parallax` element toward the cursor, eased with
  // a simple lerp each frame. Moves the CSS `translate` property (not
  // `transform`), so it composes with — rather than fights — a target's
  // own `transform`-based animation (e.g. `.floating-particle`'s float).
  var mouseParallaxRoot = document.querySelector(".js-mouse-parallax-root");
  var mouseParallaxEls = document.querySelectorAll(".js-mouse-parallax");
  if (mouseParallaxRoot && mouseParallaxEls.length && !prefersReducedMotion) {
    var parallaxTargetX = 0;
    var parallaxTargetY = 0;
    var parallaxCurrentX = 0;
    var parallaxCurrentY = 0;
    var parallaxLoopRunning = false;

    var renderMouseParallax = function () {
      parallaxCurrentX += (parallaxTargetX - parallaxCurrentX) * 0.08;
      parallaxCurrentY += (parallaxTargetY - parallaxCurrentY) * 0.08;

      mouseParallaxEls.forEach(function (el) {
        var strength = parseFloat(el.getAttribute("data-parallax-strength")) || 20;
        el.style.translate = (parallaxCurrentX * strength) + "px " + (parallaxCurrentY * strength) + "px";
      });

      var settled = Math.abs(parallaxTargetX - parallaxCurrentX) < 0.001 && Math.abs(parallaxTargetY - parallaxCurrentY) < 0.001;
      if (settled) {
        parallaxLoopRunning = false;
        return;
      }
      window.requestAnimationFrame(renderMouseParallax);
    };

    var startMouseParallaxLoop = function () {
      if (!parallaxLoopRunning) {
        parallaxLoopRunning = true;
        window.requestAnimationFrame(renderMouseParallax);
      }
    };

    mouseParallaxRoot.addEventListener("mousemove", function (e) {
      var rect = mouseParallaxRoot.getBoundingClientRect();
      parallaxTargetX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      parallaxTargetY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
      startMouseParallaxLoop();
    });

    mouseParallaxRoot.addEventListener("mouseleave", function () {
      parallaxTargetX = 0;
      parallaxTargetY = 0;
      startMouseParallaxLoop();
    });
  }

  // ─── Table of contents scrollspy ─────────────────────────────────────────
  var tocLinks = document.querySelectorAll(".js-toc-link");
  if (tocLinks.length && "IntersectionObserver" in window) {
    var headingTargets = [];
    tocLinks.forEach(function (link) {
      var id = link.getAttribute("href").slice(1);
      var heading = document.getElementById(id);
      if (heading) headingTargets.push(heading);
    });

    var tocObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var link = document.querySelector('.js-toc-link[href="#' + entry.target.id + '"]');
          if (!link) return;
          link.classList.toggle("is-active", entry.isIntersecting);
        });
      },
      { rootMargin: "-20% 0px -70% 0px" }
    );

    headingTargets.forEach(function (heading) {
      tocObserver.observe(heading);
    });
  }
});
